<template>
  <PerfectScrollbar
    ref="perfectScrollbar"
    :tag="htmlTag"
    :options="options"
    @ps-y-reach-end="$emit('rollToTheBottom')"
  >
    <slot />
  </PerfectScrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
  components: {
    PerfectScrollbar
  },
  props: ['htmlTag'],
  data() {
    return {
      options: {
        suppressScrollX: true
      }
    };
  },
  methods: {
    resetScrollbarPosition() {
      this.$nextTick(() => {
        if (this.$refs.perfectScrollbar) {
          this.$refs.perfectScrollbar.$el.scrollTop = 0;
        }
      });
    },
    update() {
      this.$nextTick(() => {
        if (this.$refs.perfectScrollbar) {
          this.$refs.perfectScrollbar.update();
        }
      });
    }
  }
};
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
